import request from "@/util/axios";

// 共享变量
var _WDG_order_tmp_ = {};

const WDG_get_order = function (WDG_order_sns) {
  return new Promise(function (resolve, reject) {
    var formData = new FormData();
    formData.append("WDG_order_sns", WDG_order_sns);

    // 查询待支付订单信息 主要是金额
    request.post("/mall/rc-wdg-order-fee", formData).then((res) => {
      budo_log.info("#14 rc-wdg-order-fee, res=", res);

      if (res && res.data) {
        res.data.orderFee = Number(res.data.amount) * 100;

        _WDG_order_tmp_ = res.data;
        resolve(res.data);
        return;
      }

      reject("rc-wdg-order-fee err");
    });
  });
};

const WDG_order_info_for_pay = function (cards) {
  budo_log.info("#30 _WDG_order_tmp_=", _WDG_order_tmp_, "cards=", cards);

  _WDG_order_tmp_.cardList = JSON.parse(JSON.stringify(cards));
  _WDG_order_tmp_.cardList.forEach((e) => {
    e.cardUseType = e.useType;
    e.quantity = e.useQuantity; // 这张卡使用了多少
  });

  _WDG_order_tmp_.goodsList = [];

  _WDG_order_tmp_.orderType = "WDG";
  _WDG_order_tmp_.goodsType = "WDG";
  _WDG_order_tmp_.tradeno = _WDG_order_tmp_.orderSn;
  _WDG_order_tmp_.expressFee = 0;

  _WDG_order_tmp_.cardMoney = _WDG_order_tmp_.cardList
    .map((e) => e.quantity)
    .reduce((sum, quantity) => sum + quantity, 0);
  _WDG_order_tmp_.wxPayFee =
    _WDG_order_tmp_.orderFee - _WDG_order_tmp_.cardMoney;

  return _WDG_order_tmp_;
};

export { WDG_get_order, WDG_order_info_for_pay };
